import { withInstall } from '@vuemap/vue-amap-util'
import Rectangle from './Rectangle.vue'

export const ElAmapRectangle = withInstall(Rectangle)
export default ElAmapRectangle
